import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5002/api",

  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  timeout: 10000,
  withCredentials: true,
});

// Injection du token d'accès
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Gestion automatique des erreurs 401 + refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_API_URL || "http://localhost:5002/api"}/auth/refresh-token`,
          {},
          { withCredentials: true }
        );

        // Stocker le nouveau token et réessayer le requête
        localStorage.setItem("token", data.accessToken);
        originalRequest.headers.Authorization = `Bearer ${data.accessToken}`;
        return axios.request(error.config);
      } catch (refreshError) {
        console.error("🔴 Token refresh failed:", refreshError);

        // Détection précise d'une session remplacée
        const type = refreshError.response?.data?.errorType;
        const reason = type === "SESSION_REPLACED" ? "replaced" : "expired";

        // Déconnexion forcée
        localStorage.removeItem("token");
        window.location.href = `/login?expired=${reason}`; // ou redirige via React Router si nécessaire
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
